import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { PrivilegiosController } from './privilegios.controller';
import { PrivilegiosService } from './privilegios.service';

@Module({
  imports: [PrismaModule],
  controllers: [PrivilegiosController],
  providers: [PrivilegiosService],
})
export class PrivilegiosModule {}
